angular.module('app').controller('NavigationAppointmentsCtrl',
    ['$scope', 'LocalStorageRepository', '$stateParams',
        function ($scope, LocalStorageRepository) {
            'use strict';

            var fullName = LocalStorageRepository.getUserFullName(),
                userID = LocalStorageRepository.getUserID();

            $scope.CurrentUser = {
                FullName: fullName + '  hello world',
                Id: userID
            };

        }]);